import { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";


function Row(props) {
    const { row, isDownIconVisible, detailsHeading, headings } = props;
    let rowName = Object.keys(row).filter(key => key !== "isDownIconVisible" && key !== "productDetails");
    const [open, setOpen] = useState(false);

    return (
        <>
            <TableRow className="table-row" hover>
                {rowName?.filter(data => data !== 'total_amount')
                    .map((data) =>
                        row?.[data] !== null && row?.[data] !== undefined && (
                            <TableCell
                                className={`my-table-data table-data ${data === "order_no" && "beige-color"}`}
                                align="left"
                                component="th"
                                scope="row"
                                key={data}
                            >
                                {data?.includes("amount")
                                    ? (headings?.some((item) => typeof item === "string" && item?.toLowerCase()?.includes("amount"))) ? row?.[data] : ""
                                    : row?.[data]}
                            </TableCell>
                        )
                    )}

                {isDownIconVisible && (
                    <TableCell className="border-top icon-button" component="th" scope="row" align="left">
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                )}
            </TableRow>
            <TableRow>
                <TableCell className="collapse-container" colSpan={8}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        {detailsHeading?.map((data, index) => (
                                            <TableCell key={index} className="table-head-class1 table-head" align="left">
                                                {data}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row.productDetails?.map((detail, index) => (
                                        <TableRow key={index}>
                                            {Object.keys(detail).map((data) => (
                                                <TableCell key={data} className="my-table-data table-head-class1" align="left" component="th" scope="row">
                                                    {detail[data]}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                    <TableRow>
                                        <TableCell className="table-data my-table-data2 table-head-class1 padding-0" align="left" component="th" scope="row">
                                            <Box className="order-amount-box">
                                                <Typography component="div" className="order-amount-text">Total order amount</Typography>
                                            </Box>
                                        </TableCell>

                                        {row?.productDetails?.[0] &&
                                            Object.keys(row?.productDetails?.[0])
                                                ?.splice(0, Object.keys(row?.productDetails?.[0])?.length - 2)
                                                ?.map((data, idx) => (
                                                    <TableCell key={data || `empty-${idx}`} className="my-table-data2 table-data table-head-class padding-0" align="left" component="th" scope="row">
                                                        <Box className="amount-box"></Box>
                                                    </TableCell>
                                                ))}

                                        <TableCell className="my-table-data2 table-data table-head-class1 padding-0" align="left" component="th" scope="row">
                                            <Box className="pending-amount-box">
                                                <Typography component="div" className="pending-amount-text">{row?.pending_amount || row?.total_amount}</Typography>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
}

export default Row;
